import { Box, Typography, useTheme } from '@mui/material';
import React, { useContext } from 'react';
import { LoginPageFormType } from '../loginPage';
import { useTranslation } from 'react-i18next';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function LoginFooter({
  activeForm,
  handleSwitchForm,
}: {
  activeForm: LoginPageFormType;
  handleSwitchForm: () => void;
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box
      sx={{
        display: 'flex',
        width: 1,
        justifyContent: 'center',
        alignItems: 'center',
        mt: -sp.s40,
        gap: '12px',
      }}
    >
      <Typography variant="f16">
        {activeForm === 'restore'
          ? 'Вспомнили пароль?'
          : activeForm === 'invite'
          ? t('login.accountExists')
          : t('login.accountDoesntExist')}
      </Typography>
      <Box
        onClick={handleSwitchForm}
        role="button"
        sx={{
          'display': 'flex',
          'justifyContent': 'center',
          'alignItems': 'center',
          'cursor': 'pointer',
          'color': theme.palette.primary.main,

          '&:hover': {
            color: theme.palette.custom.primaryMainHighlight,
          },
        }}
      >
        <Typography variant="f16">
          {activeForm === 'login'
            ? t('login.makeRegistration')
            : t('login.comeIn')}
        </Typography>
      </Box>
    </Box>
  );
}
